export default __webpack_public_path__ + "static/RoobertPRO-Bold-abecd4ef3d84fc894cf7c186fb921987.ttf";